import Title from "./Title";
import getstart from "../img/getstart.png";
import Btn from "./Btn";

export default function GetStart() {
    return <>
        <div className="getStart pt-5" >
            <div className="container position-relative" >
                <div className="discountTag m-auto d-flex align-items-center m-md-0 " >
                    <div className="badge badge-primary" >NEW</div>
                    <p>GET 30% OFF on Moving Packing Services Today!</p>
                </div>
                <div className="row" >
                    <div className="col-sm-12 col-lg-8" >
                        <Title mainClass=" d-block"
                            titleclass="xlg heading text-dark text-md-start text-center mt-4 mb-3 mb-sm-5"
                            desclass="mb-0 text-md-start text-center w-75"
                            title={<>Moving <br></br> 
                                Packaging</>}
                            des="We are so much more than just a moving company. We provide a premier experience and take the stress and anxiety out of moving." />

                        <div className="d-flex flex-wrap align-item-center   justify-content-md-start justify-content-center mt-md-5 mt-3 mb-md-5 pb-3 " >

                            <Btn class="px-5 mt-3 ms-2 me-2 ms-md-0"
                                arrow={false}
                                wave={false}
                                href="#"
                            > Get Started</Btn>

                            <Btn class="btn-grey px-4 mt-3 ms-2 me-2 ms-md-0"
                                arrow={false}
                                wave={false}
                                href="#"
                            > About Exquisite Moves</Btn>

                       
                        </div>
                    </div>
                </div>
                <div className="getstart_img" >
                    <img src={getstart} alt="get Start" className="img-fluid" />
                </div>

            </div>
        </div>
    </>
}